import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ArrowRightLeft } from 'lucide-react';
import { ExtensaoRemanejar } from '@/components/ExtensaoRemanejar';

const PERFIS = ['ADMIN', 'GERENTE'];

export default function RemanejarClaro() {
  const { user } = useAuth();
  if (user && !PERFIS.includes(user.perfil)) return <Navigate to="/dashboard" replace />;
  return (
    <div className="space-y-6" data-testid="remanejar-claro-page">
      <div>
        <h1 className="text-3xl font-bold flex items-center gap-3">
          <ArrowRightLeft className="h-8 w-8 text-red-600" />
          Remanejar Claro
        </h1>
        <p className="text-gray-500 mt-1">Extensão para remanejar colaboradores entre empresas (Agentes Autorizados) na Conexão Claro — Admin e Gerente.</p>
      </div>
      <ExtensaoRemanejar />
    </div>
  );
}
